import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-total-visible-in-footer",
  templateUrl: "./field-set-total-visible-in-footer.component.html",
  styles: [],
})
export class FieldSetTotalVisibleInFooterComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

}
